import React from 'react';
// import { FaFacebookF, FaTwitter, FaPinterestP, FaYoutube, FaBars } from 'react-icons/fa';
import yogaBanner from '../../assets/images/banner.jpg'; // Banner Image
// import logo from '../../assets/images/Logo2.PNG'; // Logo Image
import waveImg from '../../assets/images/background-white-color.png'; 
const SubPageHeader = ({ title }) => {
  return (
    <section className="w-full relative font-['Montserrat',_sans-serif]">
      
      {/* १. Top Bar - Social & Contact  */}
      <div className="absolute top-0 left-0 w-full z-50 px-10 py-2 flex justify-between items-center text-white">
        <div className="hidden md:block leading-tight">
          {/* <p className="text-[10px] tracking-widest opacity-80 uppercase">The Global School of Happiness</p>  */}
          {/* <p className="text-sm font-bold tracking-wider uppercase">Call 800 1234 56789</p> */}
        </div>

        {/* <div className="flex justify-center">
          <img src={logo} alt="logo" className="h-10 w-auto" />
        </div> */}

        {/* <div className="flex items-center gap-4 text-sm">
          <FaFacebookF className="hover:text-[#54a50f] cursor-pointer transition-colors" />
          <FaTwitter className="hover:text-[#54a50f] cursor-pointer transition-colors" />
          <FaPinterestP className="hover:text-[#54a50f] cursor-pointer transition-colors" />
          <FaYoutube className="hover:text-[#54a50f] cursor-pointer transition-colors" />
          <FaBars className="ml-4 text-xl cursor-pointer" />
        </div> */}
      </div>

      {/* २. (Banner-Another Class) */}
      <div 
        className="w-full h-[130px] sm:h-[180px] md:h-[250px] flex justify-center relative bg-cover bg-top bg-no-repeat"
        style={{
           backgroundImage: `url(${yogaBanner})`,
           backgroundSize: 'cover',
           backgroundPosition: 'center',
           backgroundAttachment:
            window.innerWidth > 768
            ? 'fixed'
            : 'scroll'
        }}
      >
        {/* */}
        <div className="absolute inset-0 bg-black/20"></div>

        {/* */}
        <div className="relative z-10 text-center text-white mt-20">
          {/* <p className="text-[12px] tracking-[6px] uppercase opacity-90 mb-2 font-medium">The Global School of Happiness</p> */}
          <h1 className="
              text-2xl
              sm:text-2xl
              md:text-5xl
              font-semibold
              px-4
              font-sans
              text-center
              break-words
          ">
            {title}
            
          </h1>
          <div className="w-20 h-[2px] bg-white/30 mx-auto mt-6"></div>
        </div>

        
        <div className="absolute bottom-[-1px] left-0 w-full z-20 pointer-events-none">
          <img 
            src={waveImg} 
            alt="wave" 
            className="w-full h-auto block" 
            style={{ maxHeight: '100px' }}
          />
        </div>
      </div>
    </section>
  );
};

export default SubPageHeader;